<script>
import getSecret from "@utils/get-secret";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import UsersUpdateForm from "@views/management/users/update-form";
import UsersCreateForm from "@views/management/users/create-form";
import UsersUpdatePwForm from "@views/management/users/update-pw-form";
import { usersMethods, authComputed } from "@state/helpers";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Administration/Users",
    meta: [{ name: "Users management", content: "Administration/Users" }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    UsersCreateForm,
    UsersUpdateForm,
    UsersUpdatePwForm,
  },
  data() {
    return {
      title: "Administration/Users",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Administration/Users",
          active: true,
        },
      ],
      users: {},
      tableHeaders: [
        {
          key: "username",
          sortable: true,
        },
        {
          key: "first_name",
          label: "Name",
          sortable: true,
        },
        {
          key: "email",
          sortable: true,
        },
        // {
        //   key: 'is_staff',
        //   label: 'Staff?',
        //   sortable: true
        // },
        {
          key: "is_superuser",
          label: "Superuser?",
          sortable: true,
        },
        {
          key: "is_active",
          label: "Active?",
          sortable: true,
        },
        "actions",
      ],
      detailModal: {
        id: "info-modal",
        title: "",
        content: "",
        photo: "",
      },
      createUpdateModal: {
        id: "create-update-modal",
        title: "",
        content: "",
      },
      createForm: {
        username: "",
        email: "",
        password: "",
        repeat_password: "",
        app_sections_users: [],
      },
      updateForm: {
        url: "",
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        // is_staff: false,
        is_superuser: false,
        is_active: true,
        is_api_user: true,
        email_subscription: true,
        user_info: {},
        groups: [],
        user_permissions: [],
        app_sections_users: [],
      },
      updatePwForm: {
        url: "",
        password: "",
        repeat_password: "",
      },
      action: "",
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
    };
  },
  validations: {
    updateForm: {
      username: {
        required,
        minLength: minLength(4),
      },
      email: { email },
      first_name: {},
      last_name: {},
    },
    createForm: {
      username: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        minLength: minLength(4),
      },
      password: {
        required,
        minLength: minLength(4),
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
    updatePwForm: {
      password: {
        required,
        minLength: minLength(4),
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...usersMethods,

    myProvider(ctx) {
      const promise = this.fetchUsers(this.$table_params(ctx));
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          return [];
        });
    },
    openDetailModal(item, index, button) {
      let context = this;
      context.isSubmitting = true;
      context.actionsLoadings[button] = true;
      context.detailModal.title = context.$t("usersSection.user") + `: ${item.username}`;
      const promise = context.fetchUsersDetail(item.url);
      return promise
        .then((data) => {
          context.detailModal.content = data;
          context.detailModal.photo =
            data.user_info && data.user_info.photo
              ? data.user_info.photo
              : require("@assets/images/users/avatar-clear.png");
          context.detailModalShow = !context.detailModalShow;
          context.isSubmitting = false;
          context.actionsLoadings[button] = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
          context.actionsLoadings[button] = false;
        });
    },
    resetdetailModal() {
      this.detailModal.title = "";
      this.detailModal.content = "";
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action);
      if (action === "create") {
        this.action = "create";
        this.createForm.username = "";
        this.createForm.email = "";
        this.createForm.password = "";
        this.createForm.repeat_password = "";
        this.createUpdateModal.title =
          this.$t("basic.new") + " " + this.$t("usersSection.user");
      } else if (action === "update") {
        this.action = "update";
        this.createUpdateModal.title =
          this.$t("basic.update") + " " + this.$t("usersSection.user");
        this.createUpdateModal.content = JSON.stringify(item, null, 2);
        this.updateForm._id = item._id;
        this.updateForm.username = item.username;
        this.updateForm.first_name = item.first_name;
        this.updateForm.last_name = item.last_name;
        this.updateForm.email = item.email;
        // this.updateForm.is_staff = item.is_staff
        this.updateForm.is_superuser = item.is_superuser;
        this.updateForm.is_active = item.is_active;
        this.updateForm.user_info = item.user_info;
        console.log(item.user_info);
        this.updateForm.email_subscription = item.user_info
          ? item.user_info.email_subscription
          : false;
        this.updateForm.is_api_user = item.user_info ? item.user_info.is_api_user : false;
        this.updateForm.user_permissions = item.user_permissions_filtered;
        this.updateForm.groups = Array.from(item.groups, (x) => x._id);
        this.updateForm.app_sections_users = item.app_sections_users;
      } else {
        this.action = "password_change";
        this.createUpdateModal.title =
          this.$t("basic.set_password") + ": " + `${item.username}`;
        this.updatePwForm._id = item._id;
      }
      this.createUpdateModalShow = !this.createUpdateModalShow;
    },
    openDeleteModal(item, index) {
      this.toDelete = item;
      this.deleteModalShow = !this.deleteModalShow;
    },
    resetDeleteModal(item, index) {
      this.toDelete = {};
    },
    deleteUser() {
      let context = this;
      context.isSubmitting = true;
      // let reservedUsers = [
      //   getSecret('APP_API_USERNAME'),
      //   context.currentSession.user.username]
      // if(!reservedUsers.includes(context.toDelete.username)){
      const promise = context.deleteUsers(context.toDelete._id);
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            "success",
            context.$t("alerts.deleted_successfully")
          );
          context.$refs.table.refresh();
          context.isSubmitting = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
        });
      // }else{
      //   context.$generate_toast(
      //     context,
      //     'error',
      //     'This user cannot be deleted because is protected or is yourself')
      //   context.isSubmitting = false
      // }
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = "";
      this.createUpdateModal.content = "";
      if (action === "create") {
        this.createForm.username = "";
        this.createForm.email = "";
        this.createForm.password = "";
        this.createForm.repeat_password = "";
        this.createForm.app_sections_users = [];
        this.$v.createForm.$reset();
      } else if (action === "update") {
        this.updateForm._id = "";
        this.updateForm.username = "";
        this.updateForm.first_name = "";
        this.updateForm.last_name = "";
        this.updateForm.email = "";
        // this.updateForm.is_staff = false
        this.updateForm.is_superuser = false;
        this.updateForm.email_subscription = true;
        this.updateForm.is_api_user = false;
        this.updateForm.is_active = true;
        this.updateForm.user_permissions = [];
        this.updateForm.groups = [];
        this.updateForm.app_sections_users = [];
        this.$v.updateForm.$reset();
      } else {
        this.updatePwForm._id = "";
        this.updatePwForm.password = "";
        this.updatePwForm.repeat_password = "";
      }
    },
    onFormSubmit(evt) {
      evt.preventDefault();
      let context = this;
      context.isSubmitting = true;
      if (context.$v.updateForm.$anyError) {
        context.$v.updateForm.$touch();
      }
      let form =
        context.action === "create"
          ? context.createForm
          : context.action === "update"
          ? context.updateForm
          : context.updatePwForm;
      const promise =
        context.action === "password_change"
          ? context.changePassword(form)
          : context.createUpdateUsers(form);
      return promise
        .then((data) => {
          if (context.action === "create") {
            context.$generate_toast(
              context,
              "success",
              context.$t("alerts.created_successfully")
            );
          } else if (context.action === "update") {
            context.$generate_toast(
              context,
              "success",
              context.$t("alerts.updated_successfully")
            );
            if (context.currentSession.user.username === form.username) {
              this.$store.dispatch("auth/validate", true);
            }
          } else {
            context.$generate_toast(
              context,
              "success",
              context.$t("login_section.password_changed_successfully")
            );
          }
          context.createUpdateModalShow = !context.createUpdateModalShow;
          context.$refs.table.refresh();
          context.isSubmitting = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
        });
    },
    async onPhotoSubmit(formData) {
      let context = this;
      context.isSubmitting = true;
      formData.append("url", context.updateForm.url);
      return context
        .updatePhotos(formData)
        .then((data) => {
          context.$generate_toast(
            context,
            "success",
            context.$t("alerts.updated_successfully")
          );
          context.isSubmitting = false;
          context.$refs.table.refresh();
          if (context.currentSession.user.username === context.updateForm.username) {
            this.$store.dispatch("auth/validate", true);
          }
          return data;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
          throw error;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card>
            <b-button
              variant="primary"
              size="sm"
              @click="openCreateUpdateModal(null, null, 'create')"
            >
              <i class="fad fa-plus"></i> {{ $t("basic.add") }}
            </b-button>
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:cell(username)="data">
                {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }}
              </template>
              <template v-slot:cell(first_name)="data">
                {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }}
                {{
                  data.item.last_name.charAt(0).toUpperCase() +
                  data.item.last_name.slice(1)
                }}
              </template>
              <!-- <template v-slot:cell(is_staff)="data">
                <i v-if="data.value" class="fad fa-circle-check" style="color: green"></i>
                <i v-if="!data.value" class="fad fa-circle-xmark" style="color: red"></i>
              </template> -->

              <template v-slot:cell(is_superuser)="data">
                <i v-if="data.value" class="fad fa-circle-check" style="color: green"></i>
                <i v-if="!data.value" class="fad fa-circle-xmark" style="color: red"></i>
              </template>

              <template v-slot:cell(is_active)="data">
                <i v-if="data.value" class="fad fa-circle-check" style="color: green"></i>
                <i v-if="!data.value" class="fad fa-circle-xmark" style="color: red"></i>
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    variant="transparent-1"
                    class="text-info p-1"
                    :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                    @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fad fa-circle-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>
                  <b-tooltip
                    :target="`info-btn-${row.index}`"
                    triggers="hover"
                    placement="left"
                    variant="info"
                  >
                    {{ $t("basic.info") }}
                  </b-tooltip>

                  <b-button
                    :id="`update-btn-${row.index}`"
                    variant="transparent-1"
                    class="text-warning p-1"
                    :disabled="isSubmitting"
                    @click="openCreateUpdateModal(row.item, row.index, 'update')"
                  >
                    <i class="fad fa-pen fe-2x"></i>
                  </b-button>
                  <b-tooltip
                    :target="`update-btn-${row.index}`"
                    triggers="hover"
                    placement="left"
                    variant="warning"
                  >
                    {{ $t("basic.update") }}
                  </b-tooltip>

                  <b-button
                    :id="`update-pw-btn-${row.index}`"
                    variant="transparent-1"
                    class="text-secondary p-1"
                    :disabled="isSubmitting"
                    @click="openCreateUpdateModal(row.item, row.index, 'password_change')"
                  >
                    <i class="fad fa-key"></i>
                  </b-button>
                  <b-tooltip
                    :target="`update-pw-btn-${row.index}`"
                    triggers="hover"
                    placement="left"
                    variant="secondary"
                  >
                    {{ $t("basic.set_password") }}
                  </b-tooltip>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    variant="transparent-1"
                    class="text-danger p-1"
                    :disabled="isSubmitting"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <i class="fad fa-trash-xmark"></i>
                  </b-button>
                  <b-tooltip
                    :target="`delete-btn-${row.index}`"
                    triggers="hover"
                    placement="left"
                    variant="danger"
                  >
                    {{ $t("basic.delete") }}
                  </b-tooltip>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- Detail modal -->
    <b-modal
      :id="detailModal.id"
      v-model="detailModalShow"
      :title="detailModal.title"
      ok-only
      @hide="resetdetailModal"
    >
      <!--{{detailModal.content}}-->
      <table>
        <tr>
          <td width="100px" valign="top">
            <img id="image_avatar" class="user-image mr-2" :src="detailModal.photo" />
          </td>
          <td>
            <b-card class="no-shadow no-body p-0 border">
              <b>{{ $t("usersSection.username") }}</b> {{ detailModal.content.username
              }}<br />
              <b>{{ $t("usersSection.name") }}</b> {{ detailModal.content.first_name }}
              {{ detailModal.content.last_name }}<br />
              <b>Email</b> {{ detailModal.content.email }}<br />
              <b>{{ $t("usersSection.superuser") }}? </b
              >{{ detailModal.content.is_superuser }}<br />
              <b>{{ $t("usersSection.email_notification") }} ? </b
              >{{
                detailModal.content.user_info
                  ? detailModal.content.user_info.email_subscription
                  : ""
              }}<br />
              <b>{{ $t("usersSection.api_user") }} ? </b
              >{{
                detailModal.content.user_info
                  ? detailModal.content.user_info.is_api_user
                  : ""
              }}<br />
              <b>{{ $t("usersSection.is_active") }}?</b>
              {{ detailModal.content.is_active }}
            </b-card>
            <b-card class="no-shadow no-body p-0 border">
              <h6 v-if="detailModal.content.groups_detail">
                {{ $t("usersSection.groups") }}
              </h6>
              <ul>
                <li
                  v-for="(groups, index) in detailModal.content.groups_detail"
                  :key="index"
                >
                  {{ _.capitalize(groups.name) }}
                </li>
              </ul>
              <h6 v-if="detailModal.content.app_user_permissions_detail">
                {{ $t("usersSection.permissions") }}
              </h6>
              <ul>
                <li
                  v-for="(permission, index) in detailModal.content
                    .app_user_permissions_detail"
                  :key="index"
                >
                  {{ _.capitalize(permission.permission.name) }}
                </li>
              </ul>
              <h6 v-if="detailModal.content.app_sections_tree">
                {{ $t("usersSection.sections") }}
              </h6>
              <ul>
                <li
                  v-for="(section, index) in detailModal.content.app_sections_tree"
                  :key="index"
                >
                  <span v-if="section.name">{{ $t("pages." + section.name) }}</span>
                </li>
              </ul>
            </b-card>
          </td>
        </tr>
      </table>
    </b-modal>

    <!-- Create-Update modal -->
    <b-modal
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' || action === 'password_change' ? 'sm' : 'lg'"
    >
      <UsersUpdateForm
        v-if="action === 'update'"
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :onphotosubmit="onPhotoSubmit"
        :form="updateForm"
      >
      </UsersUpdateForm>
      <UsersCreateForm
        v-if="action === 'create'"
        :validator="$v.createForm"
        :onformsubmit="onFormSubmit"
        :form="createForm"
      >
      </UsersCreateForm>
      <UsersUpdatePwForm
        v-if="action === 'password_change'"
        :validator="$v.updatePwForm"
        :onformsubmit="onFormSubmit"
        :form="updatePwForm"
      >
      </UsersUpdatePwForm>
      <template v-slot:modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          @click="createUpdateModalShow = !createUpdateModalShow"
        >
          {{ $t("basic.cancel") }}
        </b-button>
        <b-button
          type="submit"
          form="form"
          size="sm"
          variant="primary"
          :disabled="
            action === 'create'
              ? $v.createForm.$invalid || isSubmitting
              : action === 'update'
              ? $v.updateForm.$invalid || isSubmitting
              : $v.updatePwForm.$invalid || isSubmitting
          "
        >
          <span v-if="!isSubmitting">
            {{ $t("submit") }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      :title="$t('basic.delete') + ' ' + $t('usersSection.user')"
      :ok-title="$t('basic.delete')"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteUser"
    >
      <p>
        {{ $t("usersSection.are_you_sure") }} <b>{{ toDelete.username }}</b> ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel">
          {{ $t("basic.cancel") }}
        </b-button>
        <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
          <span v-if="!isSubmitting">
            {{ $t("delete") }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
